/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Combined_Continuity_DialogueInputs */

const en_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`COMBINED CONTINUITY & DIALOGUE`)
};

const fr_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUITE ET DIALOGUE COMBINES`)
};

const de_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KOMBINIERTE KONTINUITÄT & DIALOG`)
};

const it_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUITÀ E DIALOGO COMBINATI`)
};

const ru_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`СОВМЕСТНАЯ НЕПРЕРЫВНОСТЬ И ДИАЛОГ`)
};

const es_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUIDAD Y DIÁLOGO COMBINADOS`)
};

const zh_cn2_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连续性与对话相结合`)
};

const ja_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`連続性と対話の融合`)
};

const hi_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संयुक्त निरंतरता और संवाद`)
};

const pt_pt2_ccsl_export_header_combined_continuity_dialogue = /** @type {(inputs: Ccsl_Export_Header_Combined_Continuity_DialogueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CONTINUIDADE E DIÁLOGO COMBINADOS`)
};

/**
* | output |
* | --- |
* | "COMBINED CONTINUITY & DIALOGUE" |
*
* @param {Ccsl_Export_Header_Combined_Continuity_DialogueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_combined_continuity_dialogue = /** @type {((inputs?: Ccsl_Export_Header_Combined_Continuity_DialogueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Combined_Continuity_DialogueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "de") return de_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "it") return it_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "ru") return ru_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "es") return es_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "ja") return ja_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "hi") return hi_ccsl_export_header_combined_continuity_dialogue(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_combined_continuity_dialogue(inputs)
	return en_ccsl_export_header_combined_continuity_dialogue(inputs)
});